var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.stage === "upcoming"
    ? _c("div", { class: ["contests-carousel-item", _vm.stage] }, [
        _c("div", { staticClass: "contests-carousel-item--img-holder" }, [
          _vm.ifContestImageExists
            ? _c("img", {
                staticClass: "contests-carousel-item--image",
                attrs: { src: _vm.contestImageUrl, alt: "Contest Cover Image" }
              })
            : _c("img", {
                staticClass: "contests-carousel-item--image",
                attrs: {
                  src: require("@/assets/images/contests/contest_img_gen.png"),
                  alt: "Contest Cover Image"
                }
              })
        ]),
        _vm._v(" "),
        _c("h3", { staticClass: "contests-carousel-item--name" }, [
          _vm._v(_vm._s(_vm.contest.name))
        ]),
        _vm._v(" "),
        _vm.isContestRegistrationActive
          ? _c(
              "div",
              { staticClass: "contests-carousel-action" },
              [
                _vm.maxEntriesPerPlayer > 1
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "request-access-btn",
                        attrs: { disabled: !_vm.isLoggedIn },
                        on: { click: _vm.toggleContestRequestAccessDialog }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("Contests.Carusel.Item.Request.Access"))
                        )
                      ]
                    )
                  : _c(
                      "router-link",
                      {
                        staticClass: "request-access-btn",
                        attrs: {
                          to: {
                            name: "contests/registration/termsandconditions",
                            params: { contestId: _vm.contestId }
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("Contests.Carusel.Item.Request.Access"))
                        )
                      ]
                    ),
                _vm._v(" "),
                _c("contest-request-access-dialog", {
                  attrs: {
                    showContestRequestAccessDialog:
                      _vm.showContestRequestAccessDialog,
                    entriesLeft: _vm.entriesLeft,
                    contestId: _vm.contestId,
                    contestName: _vm.contestName
                  },
                  on: {
                    "toggle-contest-request-access-dialog":
                      _vm.toggleContestRequestAccessDialog
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "registration-time",
                    class: { disabled: !_vm.isLoggedIn }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Contests.Carusel.Item.Registration.Ends")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.registrationEndUtcTime))])
                  ]
                )
              ],
              1
            )
          : _c(
              "div",
              {
                staticClass: "contests-carousel-not-active",
                class: { disabled: !_vm.isLoggedIn }
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("Contests.Carusel.Item.Registration.Starts"))
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.registrationStartUtcTime))])
              ]
            )
      ])
    : _vm.stage === "entered"
    ? _c(
        "div",
        { class: ["contests-carousel-item", _vm.stage] },
        [
          _vm.contestObj.contest.phase === "ACT"
            ? _c(
                "router-link",
                {
                  staticClass: "my-picks-img",
                  attrs: {
                    to: {
                      name: "contests/my-picks",
                      params: {
                        contestId: _vm.contestId,
                        contestEntryId: _vm.contestEntryId
                      }
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "contests-carousel-item--img-holder" },
                    [
                      _vm.ifContestImageExists
                        ? _c("img", {
                            staticClass: "contests-carousel-item--image",
                            attrs: {
                              src: _vm.contestImageUrl,
                              alt: "Contest Cover Image"
                            }
                          })
                        : _c("img", {
                            staticClass: "contests-carousel-item--image",
                            attrs: {
                              src: require("@/assets/images/contests/contest_img_gen.png"),
                              alt: "Contest Cover Image"
                            }
                          })
                    ]
                  )
                ]
              )
            : _c(
                "a",
                { on: { click: _vm.toggleContestEnteredDialog } },
                [
                  _c(
                    "div",
                    { staticClass: "contests-carousel-item--img-holder" },
                    [
                      _vm.ifContestImageExists
                        ? _c("img", {
                            staticClass: "contests-carousel-item--image",
                            attrs: {
                              src: _vm.contestImageUrl,
                              alt: "Contest Cover Image"
                            }
                          })
                        : _c("img", {
                            staticClass: "contests-carousel-item--image",
                            attrs: {
                              src: require("@/assets/images/contests/contest_img_gen.png"),
                              alt: "Contest Cover Image"
                            }
                          })
                    ]
                  ),
                  _vm._v(" "),
                  _c("contest-entered-dialog", {
                    attrs: {
                      contestAlias: this.contestObj.alias,
                      contestName: this.contest.name,
                      showContestEnteredDialog: _vm.showContestEnteredDialog,
                      contestStartTime: this.startUtcTime
                    },
                    on: {
                      "toggle-contest-entered-dialog":
                        _vm.toggleContestEnteredDialog
                    }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _c("div", { staticClass: "contests-ent-carousel-item-body" }, [
            _c("div", { staticClass: "carousel-item-body--names" }, [
              _c("h2", { staticClass: "contests-carousel-item--alias" }, [
                _vm._v(_vm._s(_vm.contestObj.alias))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "contests-carousel-item--name" }, [
                _vm._v(_vm._s(_vm.contest.name))
              ])
            ]),
            _vm._v(" "),
            _vm.contestObj.contest.phase === "ACT"
              ? _c("div", { staticClass: "carousel-item-body--details" }, [
                  _c("span", { staticClass: "contests-carousel-item--rank" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Contests.Leaderboard.Position.Table.Rank")
                      ) +
                        " " +
                        _vm._s(_vm.contestObj.rank)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "contests-carousel-item--round" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Contests.My.Pick.History.Table.Round.No")
                      ) +
                        " " +
                        _vm._s(_vm.contestObj.round.roundNo)
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.contestObj.contest.phase === "ACT"
            ? _c("div", { staticClass: "time-active-contest" }, [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$t("Contests.Picks.Body.Time.Left")) +
                    " " +
                    _vm._s(_vm.currentRoundEndUtcTime) +
                    "\n  "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.contestObj.contest.phase === "ENT"
            ? _c("div", { staticClass: "time-entry-contest" }, [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$t("Contests.Carusel.Item.Starts.In")) +
                    " " +
                    _vm._s(_vm.startUtcTime) +
                    "\n  "
                )
              ])
            : _vm._e()
        ],
        1
      )
    : _vm.stage === "completed"
    ? _c("div", { class: ["contests-carousel-item", _vm.stage] }, [
        _c("div", { staticClass: "contests-carousel-item--img-holder" }, [
          _vm.ifContestImageExists
            ? _c("img", {
                staticClass: "contests-carousel-item--image",
                attrs: {
                  src: _vm.contestGenericImg,
                  alt: "Contest Cover Image"
                }
              })
            : _c("img", {
                staticClass: "contests-carousel-item--image",
                attrs: {
                  src: require("@/assets/images/contests/contest_img_gen.png"),
                  alt: "Contest Cover Image"
                }
              })
        ]),
        _vm._v(" "),
        _c("h3", { staticClass: "contests-carousel-item--name" }, [
          _vm._v(_vm._s(_vm.contest.name))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ent-time-contest" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("Contests.Carusel.Item.Ended")))]),
          _vm._v(
            " " + _vm._s(_vm._f("formatDates")(_vm.contest.endTimeUtc)) + "\n  "
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f69afa7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f69afa7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestsCarouselItem.vue
// module id = null
// module chunks = 